export default __webpack_public_path__ + "static/SOSWEET_BLUE-c665136ecce564bf36cdd59241ddb3f2.png";